import React from "react";
import Card from "@amzn/meridian/esm/components/card";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Box from "@amzn/meridian/esm/components/box";
import Icon from "@amzn/meridian/esm/components/icon";
import Link from "@amzn/meridian/esm/components/link";
import Theme from "@amzn/meridian/esm/components/theme";
import Tag from "@amzn/meridian/esm/components/tag";
import calendarTokens from "@amzn/meridian-tokens/base/icon/calendar";
import alertKnockout from "@amzn/meridian-tokens/base/icon/alert-knockout";
import errorKnockout from "@amzn/meridian-tokens/base/icon/error-knockout";

const SummaryCard = ({ summary, onViewMoreClick }) => {
  const MAX_OVERVIEW_CHAR = 110;
  const MAX_TITLE_CHAR = 30;

  const { meetingTitle, meetingDateAndTime, summaryHighlight, summaryType, role } = summary;

  const getTrimmedOverview = () => {
    if (!summaryHighlight) {
      return "";
    } else if (summaryHighlight.length <= MAX_OVERVIEW_CHAR) {
      return summaryHighlight;
    } else {
      return summaryHighlight.slice(0, MAX_OVERVIEW_CHAR).trimEnd() + "…more";
    }
  };

  //TODO: make it more fit
  const getTrimmedTitle = () => {
    if (meetingTitle.length <= MAX_TITLE_CHAR) return meetingTitle;
    return meetingTitle.slice(0, MAX_TITLE_CHAR).trimEnd() + "…";
  };

  const renderStatusIcon = (iconToken, color) => (
    <Column spacing="none" spacingInset="none" alignmentVertical="top" alignmentHorizontal="start">
      <Column>
        <Column height="8px" />
        <Column height="16px">
          <Icon tokens={iconToken} color={color} />
        </Column>
        <Column height="138px" />
      </Column>
    </Column>
  );

  return (
    <Theme tokens={{ cardDropShadowDefaultBlur: "0px" }}>
      <Card width="306px" spacingInset="none" onClick={() => onViewMoreClick(summary)}>
        <Row widths={["24px", "256px", "20px"]} height="162px" spacing="none" spacingInset="none">
          <Row width="24px" />
          <Column spacing="none" spacingInset="none" alignmentHorizontal="start">
            <Column height="16px" />
            <Box spacing="none" spacingInset="none" minHeight={18} width="256px">
              <Row spacing="300" alignmentVertical="center">
                <Text type="h50">
                  {getTrimmedTitle()}
                </Text>
                {summary.summaryDetailLevel && summary.summaryDetailLevel !== "concise" && (
                  <Tag type="success">
                    {summary.summaryDetailLevel.charAt(0).toUpperCase() + summary.summaryDetailLevel.slice(1)}
                  </Tag>
                )}
              </Row>
            </Box>
            <Column height="8px" />
            <Row spacing="none" spacingInset="none">
              <Icon tokens={calendarTokens} color="secondary" />
              <Row width="4px" />
              <Text type="b100" className="summary-time" color="secondary">
                {meetingDateAndTime}
              </Text>
            </Row>
            <Column height="16px" />

            {/*Overview box*/}
            <Box width="260px" height="48px" style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
              <Text type="b100" color="secondary">
                {getTrimmedOverview()}
              </Text>
            </Box>

            <Column height="8px" />
            <Box height="16px" width="98px" spacing="none" spacingInset="none">
              <Theme tokens={{ textColorPrimary: "#006D5B" }}>
                <Link type="secondary" onClick={() => onViewMoreClick(summary)}>
                  <Text color="primary" type="b100" fontFamily="amazonEmber">
                    View more
                  </Text>
                </Link>
              </Theme>
            </Box>
            <Column height="14px" />
          </Column>

          {/*Show icon based on backend-provided iconType*/}
          {summary.iconType === "warning" && renderStatusIcon(alertKnockout, "warning")}
          {summary.iconType === "error" && renderStatusIcon(errorKnockout, "error")}
        </Row>
      </Card>
    </Theme>
  );
};

export default SummaryCard;
